import React, { useReducer, useEffect } from "react";
import {
    faqStatus as faqReducer,
    initialState as faqInitialState
} from "../reducers";
import { useInternationalization } from "../hooks/useInternationalization";
import { faqActions } from "../actions";
import { Header } from "../components/Header";
import { FaqBody } from "../components/FaqBody";
import { Loader } from "../components/Loader";
import { useIntl } from "react-intl";

export const Faq = ({ history }) => {
    const [faqState, updateFaqList] = useReducer(faqReducer, faqInitialState);
    const { locale } = useInternationalization();
    const intl = useIntl();

    useEffect(() => {
        faqActions.hospitalFaq(updateFaqList, intl);
    }, [locale])

    return (
        <React.Fragment>
            <Header history={history} />
            {faqState.loading ?
                <Loader />
                :
                <FaqBody faqState={faqState} />
            }
        </React.Fragment>
    )
}